import React, { useEffect } from 'react';
import styled from 'styled-components';
import style from './ModalPopUp.style';
import { layouts } from 'seal-ui-components';

const ModalPopUp = ({ children, className, onRequestClose }) => {
    // Use useEffect to add an event listener to the document
    useEffect(() => {
        function onKeyDown(event) {
            if (event.keyCode === 27) {
                // Close the modal when the Escape key is pressed
                onRequestClose();
            }
        }
        document.addEventListener('keydown', onKeyDown);
        return () => {
            document.removeEventListener('keydown', onKeyDown);
        };
    });

    return <layouts.VerticalBox className={className}>{children}</layouts.VerticalBox>;
};

export default styled(ModalPopUp)`
    ${style};
`;
